// extracted by css-extract-rspack-plugin
export default {"tag":"tag-fPSOdI","inProgress":"inProgress-kWfe72","finished":"finished-E22xdo","failed":"failed-F67D9N","neutral":"neutral-Ztb5vX"};